var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grafico-line-container"},[_c('div',{staticClass:"grafico-line-canvas-wrapper"},[_c('canvas',{ref:"elemento",attrs:{"id":"lineCurvaDesgasteNeumatico"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }